"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITOP_TICKET_OPERATIONAL_STATUS_MAP = void 0;
exports.ITOP_TICKET_OPERATIONAL_STATUS_MAP = {
    ongoing: 'En Proceso',
    closed: 'Cerrado',
    resolved: 'Solucionado',
};
